import React from 'react'
import styled, { css } from 'styled-components'

export const DropdownInput = styled.input.attrs({ type: 'checkbox' })`
  display: none;
`

const Wrapper = styled.div`
  display: none;
  padding-left: 15px;

  ${DropdownInput}:checked ~ & {
    display: block;
  }

  > ul {
    margin: 0 0 6px 0;
  }
`

export const DropdownTitle = styled.a<{ isActive: boolean }>`
  cursor: pointer;
  display: flex;
  position: relative;
  align-items: center;

  ${DropdownInput}:checked ~ label & {
    margin-bottom: 6px;
    color: ${({ theme }) => theme.palette.giphyCharcoal};
    font-weight: normal;
  }

  &:before {
    position: absolute;
    content: '';
    left: 0;
    width: 0;
    height: 0;

    border-top: 5px solid transparent;
    border-bottom: 5px solid transparent;
    border-left: 5px solid #4e4e4e;
    transition: transform 0.2s ease;

    ${DropdownInput}:checked ~ label & {
      transform: rotate(90deg);
    }
  }

  ${({ isActive }) =>
    isActive &&
    css`
      && {
        color: ${({ theme }) => theme.palette.giphyLightBlue};
        font-weight: bold;
      }
    `}
`

type DropdownProps = {
  title: string
  isOpen: boolean
  isActive: boolean
}

export const Dropdown: React.FC<DropdownProps> = ({ title, children, isOpen, isActive }) => (
  <>
    <DropdownInput id={title} defaultChecked={isOpen} />
    <label htmlFor={title}>
      <DropdownTitle isActive={isActive}>{title}</DropdownTitle>
    </label>
    <Wrapper>{children}</Wrapper>
  </>
)
